import * as am5 from '@amcharts/amcharts5'
import { montserrat } from 'styles/variables'

class BaseTheme extends am5.Theme {
    setupDefaultRules() {

        this.rule("AxisRenderer").setAll({
            strokeWidth: 2,
            strokeOpacity: 1,
            stroke: am5.color('#FFF'),
        });

        this.rule("Label", ["axis", "x"]).setAll({
            fill: am5.color('#779997'),
            fontFamily: montserrat.style.fontFamily,
            fontSize: 16,
        });

        this.rule("Label", ["axis", "y"]).setAll({
            fill: am5.color('#779997'),
            fontFamily: montserrat.style.fontFamily,
            fontSize: 16,
            paddingRight: 15,
        });

        this.rule("AxisLabel", ["x"]).setAll({
            paddingTop: 15,
        });
        this.rule("AxisLabel", ["y"]).setAll({
            paddingRight: 15,
        });

        this.rule("RoundedRectangle", ["scrollbar", "thumb"]).setAll({
            fill: '#F3F2E5',
        });

        this.rule("RoundedRectangle", ["scrollbar", "thumb"]).states.create("hover", {
            fill: '#F3F2E5',
        });

        this.rule("RoundedRectangle", ["scrollbar", "button", "background"]).setAll({
            fill: '#F3F2E5',
        });

        this.rule("RoundedRectangle", ["scrollbar", "button", "background"]).states.create("hover", {
            fill: '#F3F2E5',
        });

    }
}

export default BaseTheme;